import React, {useRef} from 'react';
import loadable from '@loadable/component';
import './ListingProducts.scss';
import {useListingContext} from '../../context/ListingContext';
import EmptyListing from "../EmptyListing/EmptyListing";
import Loader from "../Loader/Loader";

const ReactPaginate = loadable(() => import('react-paginate'));
const Products = loadable(() => import('../../components/Category/Products/Products'));
export default () => {

    const {
        products,
        listingParams,
        setListingParams,
        loading
    } = useListingContext();

    const ref = useRef(null);

    const isEmpty = !products || products.length === 0;

    console.log('ListingProducts render:', { 
        products: products?.length || 0, 
        loading, 
        isEmpty,
        productsType: typeof products,
        productsArray: Array.isArray(products)
    });

    if (loading) {
        return (
            <Loader/>
        );
    }

    if (isEmpty) {
        return (
            <EmptyListing/>
        );
    }

    return (
        <div ref={ref}>
            <Products items={products}/>
        </div>
    )

};
